// INSTRUMENT: Management SJT (Standalone · AXIS360 Verify Express)
// Science: Motowidlo (2003) procedural knowledge · Tacit knowledge theory (Wagner & Sternberg)
// Format: 24 scenarios · Most/Least effective response · 30 min
// Norms: Global & Indian norms (n=7K+)
// Standards: none claimed; platform-specific validity evidence not yet published
import { SJT_MANAGEMENT_ITEMS } from "./questionBank.js";
import { scoreSJT_MGMT, SJT_MGMT_NORMS, SJT_MGMT_BANDS, SJT_MGMT_DIMENSIONS } from "./scoring.js";

export { SJT_MGMT_NORMS, SJT_MGMT_BANDS, SJT_MGMT_DIMENSIONS };

const ManagementSJT = {
  id:"sjt_management", name:"Management SJT", shortName:"Management SJT",
  icon:"💼", color:"#7c3aed", bg:"#f5f3ff",
  description:"24 realistic management scenarios assessing judgement across delegation, performance management, conflict resolution, team development, decision making, communication, operational management and managing up. Validated against Indian team leaders and mid-level managers.",
  desc:"24 scenarios · Most/Least format · 30 minutes · Auto-scored",
  publisher:"AXIS360 Express", version:"1.0",
  itemCount:24, items:24, timeLimit:30, time:"30 min", timeEstimate:"30 minutes",
  format:"sjt", isSJT:true, isExpress:true, pricingTier:"volume", creditCost:20,
  predicts:["First-year manager performance","Team engagement scores","Promotion readiness","Assessment centre performance"],
  questions: SJT_MANAGEMENT_ITEMS,
  score(answers) {
    const most  = answers.most  || answers;
    const least = answers.least || new Array(SJT_MANAGEMENT_ITEMS.length).fill(null);
    return scoreSJT_MGMT(most, least);
  },
  nineboxAxes:{ x:{label:"Management Judgement",scaleIds:["sjt_management"]}, y:{label:"Management Judgement",scaleIds:["sjt_management"]} },
};
export default ManagementSJT;
